import { render } from "./cipc_report.html?vue&type=template&id=bd2f501e&scoped=true&external"
import script from "./cipc_report.js?vue&type=script&lang=js&external"
export * from "./cipc_report.js?vue&type=script&lang=js&external"

import "./CIPCReport.vue?vue&type=style&index=0&id=bd2f501e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2f501e"]])

export default __exports__